import React from 'react'
import Box from '@material-ui/core/Box'
import CurrentUserCard from '../../components/current-user-card'
import { CurrentUserLoginButton, CurrentUserLogoutLink } from '../../components/login-actions'

const AuthenticatedView = ({ currentUser }) => {
  return (
    <>
      <Box mb={3}>
        <CurrentUserCard
          currentUser={currentUser}
          action={<CurrentUserLogoutLink currentUser={currentUser}>Not you?</CurrentUserLogoutLink>}
        />
      </Box>
      <Box mb={8}>
        <CurrentUserLoginButton fullWidth color="primary" variant="contained" size="large" />
      </Box>
    </>
  )
}

export default AuthenticatedView
